import { useTranslations } from 'use-intl';

export default function ProjectUsabilityHandsfreeThankYouStep() {
  const t = useTranslations('Usability');

  return (
    <div
      className='flex shrink-0 flex-col gap-2 p-6'
      data-test='handsfree-stuck-thank-you'
    >
      <h2 className='text-base font-semibold text-gray-900'>{t('thankYou')}</h2>
      <p className='text-sm/relaxed text-gray-600'>{t('investigateProblem')}</p>
    </div>
  );
}
